export class SubScenePlugin extends Phaser.Plugins.ScenePlugin {
  constructor(scene, pluginManager) {
    super(scene, pluginManager);
    this.events = new Phaser.Events.EventEmitter();
  }

  // =============================================================================================
  // ENABLE / DISABLE
  // =============================================================================================

  enable() {
    if (this._enabled) return;
    this._enabled = true;
    this._addSceneListeners();
  }

  disable() {
    if (this._enabled) {
      this._enabled = false;
      this._removeSceneListeners();
    }
  }

  // =============================================================================================
  // START / STOP STATES
  // =============================================================================================

  start(sceneid, properties, { pauseMainScene = true }) {
    this.closeActiveSubscene();
    this._keepmainPaused = pauseMainScene;
    if (this._keepmainPaused) this._pauseMainScene();
    this._subscene = this.scene.scene.get(sceneid);
    this._subscene.events.once('shutdown', this.handleSubsceneComplete, this);
    this.scene.scene.launch(sceneid, properties);
    this._subscene.scene.moveAbove(this.scene.scene.key, this._subscene.scene.key);
    // if (this.game.hud) this.game.hud.scene.scene.bringToTop();
    this.enable();
  }

  stop(sceneid) {
    if (this._subscene && this._subscene.scene.key == sceneid) this.closeActiveSubscene();
  }

  closeActiveSubscene() {
    if (this._subscene) {
      this._subscene.events.off('shutdown', this.handleSubsceneComplete, this);
      this._subscene.scene.sendToBack();
      this._subscene.scene.stop();
      this._subscene = null;
    }
    if (this._keepmainPaused) this._resumeMainScene();
  }

  handleSubsceneComplete() {
    this.closeActiveSubscene();
    this.events.emit('shutdown');
  }

  // =============================================================================================
  // SCENE EVENTS
  // =============================================================================================

  _addSceneListeners() {
    this.scene.events.on('pause', this._handleScenePause, this);
    this.scene.events.on('resume', this._handleSceneResume, this);
    this.scene.events.on('shutdown', this._handleSceneShutdown, this);
  }

  _removeSceneListeners() {
    this.scene.events.off('pause', this._handleScenePause, this);
    this.scene.events.off('resume', this._handleSceneResume, this);
    this.scene.events.off('shutdown', this._handleSceneShutdown, this);
  }

  _handleScenePause(a, data) {
    if (!data?.internal && this._subscene) this._subscene.scene.pause();
  }

  _handleSceneResume(a, data) {
    if (!data?.internal && this._subscene) {
      if (this._keepmainPaused) this._pauseMainScene();
      this._subscene.scene.moveAbove(this.scene.scene.key, this._subscene.scene.key);
      this._subscene.scene.resume();
    }
  }

  _handleSceneShutdown() {
    this.closeActiveSubscene();
    this.events.removeAllListeners();
    this.disable();
  }

  _pauseMainScene() {
    if (!this.scene.scene.isPaused()) {
      this.scene.scene.pause(this.scene.scene.key, { internal: true });
    }
  }
  _resumeMainScene() {
    if (this.scene.scene.isPaused()) {
      this.scene.scene.resume(this.scene.scene.key, { internal: true });
    }
  }
}
